'use client'
import React, { useState, useEffect } from 'react'
import { useSession } from 'next-auth/react'
import Image from 'next/image'
import { AiOutlineLayout, AiFillHeart, AiOutlineHeart } from "react-icons/ai"
import tailwindConfig from '@tailwind.config'
import CurrencySymbol from '@components/CurrencySymbol'
import { sendLike } from '@services/sendLike'
import LinkComponent from './LinkComponent'
import { IoBed } from "react-icons/io5";
import { TbBathFilled } from "react-icons/tb";



const MapPropertyCard = ({ property, saleType, dictionary, lang }) => {

    const [showLikeBtn, setShowLikeBtn] = useState(false)
    const [isLiked, setIsLiked] = useState(property.isLiked)
    const { data: session } = useSession()

    const handleLike = async () => {
        const isLike = await sendLike(property.id, session?.user?.email)
        setIsLiked((prevLike) => !prevLike)
        property.isLiked = !property.isLiked
    };

    useEffect(() => {
        if (session !== null) {
            setShowLikeBtn(true)
        }
    }, [])

    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
        height: 70,
        overflow: 'hidden',
        z: 10
    };
    return (
        <div className='relative w-[200px]'>
            {(showLikeBtn == true && isLiked == false) && (
                <div title="Left-click on this icon to save this property" onClick={handleLike} className='absolute flex flex-row flex-wrap top-1 right-1 z-40 h-8 w-8 justify-center items-center border-[1px] border-secondary rounded-md p-1'>
                    <AiOutlineHeart
                        size={24}
                        color={tailwindConfig.theme.extend.colors.secondary}
                    />
                </div>
            )}
            {(showLikeBtn == true && isLiked == true) && (
                <div title="Left-click to unlike this property" onClick={handleLike} className='absolute flex flex-row flex-wrap top-1 right-1 z-40 h-8 w-8 justify-center items-center border-[1px] border-third rounded-md p-1'>
                    <AiFillHeart
                        size={24}
                        color={tailwindConfig.theme.extend.colors.third}
                    />
                </div>
            )}
            <div className='relative w-[200px] h-[140px] rounded-md overflow-hidden'>
                <Image
                    placeholder="blur"
                    blurDataURL={property.blur}
                    // className='object-fit'
                    className='object-cover'
                    src={property.cover}
                    // width={imageWidth}
                    // height={imageHeight}
                    fill={true}
                    alt={property.slug}
                />
                {property.isPromotion ? (
                    <div className='absolute top-2 bg-third text-light p-1 rounded-r-md z-10 font-semibold'>{property.promotionTitle}</div>
                ) : null
                }
                {property.publicTransport ? (
                    <div className='absolute flex flex-row flex-wrap bottom-0 left-0'>
                        {property.publicTransport.map((transport, index) => (
                            <div key={index} style={{ backgroundColor: transport.colorCode }} className={`rounded-sm text-light text-md px-1 ml-1 mb-1`}>{transport.type.toUpperCase()} {transport.stationName}</div>
                        ))}
                    </div>
                ) : null}
            </div>
            <div className='w-[200px] mt-1'>
                <div className='w-[200px] text-md font-semibold text-maincolor relative flex flex-col justify-between sm:overflow-hidden sm:h-[36px] h-full' title={property.enName}>
                    <h2 className='line-clamp-2'>
                        {property.name}
                    </h2>
                </div>
                <div className='flex flex-row items-center justify-between'>
                    <div>
                        {saleType == 'sale' && (
                            <div className='text-md font-semibold text-third'><CurrencySymbol lang={lang} />{property.salePrice}</div>
                        )}
                        {saleType == 'rent' && (
                            <div className='text-md font-semibold text-third'><CurrencySymbol lang={lang} />{property.rentPrice}{property.saleType === 'rent' ? '/month' : ''}</div>
                        )}
                        {property.category == 'Land' ? (
                            <div className='flex flex-row'>
                                <div className='flex flex-row items-center'>
                                    <span className='mr-1 text-maincolor'>{property.livingArea} {dictionary.sqm}</span>
                                    <AiOutlineLayout
                                        color={tailwindConfig.theme.extend.colors.secondary}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className='flex flex-row'>
                                {(property.category.toLowerCase() === 'condo' || property.category.toLowerCase() === 'house') &&
                                    <div className='flex flex-row items-center mr-2'>
                                        <span className='mr-1 text-maincolor'>{property.bedrooms}</span>
                                        <IoBed
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                        />
                                    </div>
                                }
                                {(property.category.toLowerCase() === 'condo' || property.category.toLowerCase() === 'house') &&
                                    <div className='flex flex-row items-center mr-2'>
                                        <span className='mr-1 text-maincolor'>{property.bathrooms}</span>
                                        <TbBathFilled
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                        />
                                    </div>
                                }
                                <div className='flex flex-row items-center'>
                                    <span className='mr-1 text-maincolor'>{property.livingArea} {dictionary.sqm}</span>
                                    <AiOutlineLayout
                                        color={tailwindConfig.theme.extend.colors.secondary}
                                    />
                                </div>
                            </div>
                        )
                        }
                    </div>
                    <div>
                        <LinkComponent
                            className='w-full rounded-full px-2 text-center p-1 mt-1 bg-maincolor text-light'
                            href={'/properties/' + property.slug}
                        >{dictionary.card.view}</LinkComponent>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MapPropertyCard